module.exports = __webpack_public_path__ + "img/presentation-en-haut.62eb73d6.jpg";